import { useAuthContext } from '../contexts/AuthContext';
import type { UserRole } from '../types';

export function useAuth() {
  const context = useAuthContext();

  const hasRole = (roles: UserRole | UserRole[]): boolean => {
    if (!context.user) return false;
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(context.user.role);
  };

  const isAdmin = context.user?.role === 'admin';
  const isReviewer = context.user?.role === 'reviewer' || isAdmin;
  const isUser = !!context.user;

  return {
    ...context,
    hasRole,
    isAdmin,
    isReviewer,
    isUser,
  };
}
